import React from "react"
import { Switch } from "react-router-dom"
import { Box } from "@infotech/uikit-grid"
import Toasts from "@infotech/uikit-toasts"
import Calendar from "src/routes/Calendar"
import Resources from "src/routes/Resources"
import ResourceTypes from "src/routes/ResourceTypes"
import Events from "src/routes/Events"
import EventTypes from "src/routes/EventTypes"
import PlanUUID from "src/routes/PlanUUID"
import Plans from "src/routes/Plans"
import PlanTypes from "src/routes/PlanTypes"
import ReportTemplates from "src/routes/ReportTemplates"
import Roles from "src/routes/Roles"
import NotFound from "src/routes/NotFound"
import fullHeight from "src/hocs/fullHeight"
import { accessControl } from "src/engine/modules/session/hocs"
import { SIDEBAR_COMPACT_WIDTH } from "src/engine/modules/ui"
import LoadPermissions from "src/components/LoadPermissions"
import "./index.css"

const FullHeight = fullHeight(Box)

export default accessControl(() => {
  return (
    <FullHeight>
      <LoadPermissions />
      <div
        style={{
          paddingLeft: SIDEBAR_COMPACT_WIDTH + 16,
        }}
      >
        <Toasts />
      </div>
      <Switch>
        {Calendar}
        {Plans}
        {PlanTypes}
        {Resources}
        {ResourceTypes}
        {Events}
        {EventTypes}
        {ReportTemplates}
        {PlanUUID}
        {Roles}
        {NotFound}
      </Switch>
    </FullHeight>
  )
})
